import LinkToDocusaurus from '../LinkToDocusaurus'
import { suts } from '../../docs-routes'

const LinkToSutsEmptyStateDoc = () =>
  <LinkToDocusaurus path={suts}>
    Learn more about SUTs
  </LinkToDocusaurus>

export default LinkToSutsEmptyStateDoc
